const ViewTalentsApply = () => import('../modules/xmsb/energy/operators/ViewTalentsApplyGzl')

export default [
  {

    path: '/talentsapplyview',
    name: 'talentsapplyview',
    component: ViewTalentsApply,
    meta: {
      title: '2019年优秀领军人才创业企业资助奖励申报',
      fullscreen: true,

    },
  },
]
